import React, { useState, useEffect } from "react";
import DashboardHome from "./DashboardHome";
import DashboardHeader from "./DashboardHeader";
import { Data } from "./data/data";

function Dashboard(props) {
  const [user, setUser] = useState({});

  // Get the bearer token
  const token = localStorage.getItem("myToken");

  useEffect(() => {
    userProfile();
  }, [setUser]);

  const userProfile = async () => {
    try {
      const url = `https://studyapp-api.vercel.app/api/v1/my-profile`;
      const options = {
        method: "GET",
        headers: {
          authorization: `Bearer ${token}`,
        },
      };

      const res = await fetch(url, options);
      const result = await res.json();

      const data = await result.data;
      console.log(data);

      // update the user state
      await setUser(data);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <div className="main-dashboard">
        {/* <h3>
          {user.fullName ? `Welcome back ${user.fullName}` : "fetching user..."}
        </h3> */}
        <DashboardHeader name={user.fullName} />
        <DashboardHome name={user.fullName} items={Data.items} />
      </div>
    </div>
  );
}

export default Dashboard;
